/* 
 * Export component file to be used on project
*/

import MenuMobile from './MenuMobile.js';
export default MenuMobile;
